import { Checkbox } from "@/components/ui/checkbox";
import type { ChecklistItem } from "@/types/hld-wizard";

interface ChecklistItemsProps {
  items: ChecklistItem[];
  checked: string[];
  onToggle: (id: string) => void;
  disabled?: boolean;
}

export function ChecklistItems({
  items,
  checked,
  onToggle,
  disabled,
}: ChecklistItemsProps) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <label
          key={item.id}
          className="flex items-start gap-3 rounded-lg border border-border p-3 transition-colors hover:bg-accent/50 has-[:checked]:border-primary/30 has-[:checked]:bg-primary/5"
        >
          <Checkbox
            checked={checked.includes(item.id)}
            onCheckedChange={() => onToggle(item.id)}
            disabled={disabled}
            className="mt-0.5"
          />
          <span className="text-sm leading-relaxed">{item.text}</span>
        </label>
      ))}
    </div>
  );
}
